export enum MeritPromotionState {
  None = 'None',
  Requested = 'Requested',
  RequestedCb = 'RequestedCb',
  InProgress = 'InProgress',
  Rejected = 'Rejected',
  Finalized = 'Finalized'
}
